import { Component, OnInit } from '@angular/core';
import { Participant } from 'src/app/shared/models/Participant';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { Form0ChurchAdress } from 'src/app/shared/models/Form0ChurchAdress';
import { WrkSessAssist } from 'src/app/shared/models/WrkSessAssist';
import { ParticipantServiceSession } from 'src/app/shared/models/ParticipantServiceSession';
import { WsAttendanceKey } from 'src/app/shared/models/WsAttendanceKey';
import { WSAttendance } from 'src/app/shared/models/WSAttendance';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
@Component({
  selector: 'app-workshop-session-assist',
  templateUrl: './workshop-session-assist.component.html',
  styleUrls: ['./workshop-session-assist.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopSessionAssistComponent implements OnInit {

  //Elementos de traducción inicio.
lstRespTranslate: TranslateRelLabelVO[];
lbl_name: string="name_";
lbl_church: string="churchs_";
lbl_Service:string="service_";
lbl_schedule:string="schedule_";
lbl_session:string="session_";
lbl_date:string="date_";
lbl_participants:string="participants_";
lbl_id:string="id_";
lbl_last_name:string="last_name_";
lbl_search:string="search_";
lbl_back:string="back_";
lbl_total:string="total_";
lbl_there_are:string="there_are_";
lbl_number:string="number_";
lbl_attendance:String="attendance_";
lbl_place_where_provide:string="place_where_provide_";
 //Elementos de traducción fin
  //Elementos de seguridad inicio
  token: string;
  security: SecurityDocument;
//Elementos de seguridad fin


  wrksId: string;
  listParticipantAssist : ParticipantServiceSession[];
  selectedParticipantAssist :ParticipantServiceSession;
  form0Detail: Form0ChurchAdress;
  session: WrkSessAssist;
  totalAssist: number = 0;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
      const navigation = this.router.getCurrentNavigation();
      const dataParent = navigation.extras.state;
      if(dataParent){
        this.form0Detail = dataParent.service as Form0ChurchAdress;
        this.session = dataParent.session as WrkSessAssist;
        this.token   = dataParent.token as string;
        this.loadSessionAssistByServices();
        this.getSecurity();
      }else{
        this.redirectParent();
      }
    }

  ngOnInit(): void {
  }

  loadSessionAssistByServices(){
    this.apiService.getListPartSessionByService(this.form0Detail.wrksId, this.session.sessNum).then(
      participants => {
        this.listParticipantAssist = participants;
        this.countAssist();
    });

  }

  redirectParent(){
    let params = {};
    if(this.form0Detail){
      params["wrksId"] =  this.form0Detail.wrksId; 
      params["token"] =  this.token; 
    }
    this.router.navigate(['secretary/sessionWrks'],{ queryParams: params });
  }

  onChangeAssist(participantAssist :ParticipantServiceSession){
    let id:WsAttendanceKey = {
      wrksId: this.form0Detail.wrksId,
      particiId: participantAssist.participant.particiId,
      sessNum: this.session.sessNum
    }

    let attendId = "";
    if(participantAssist.isAssist){
      attendId = "A";
    }else{
      attendId = "N";
    }

    let attendance:WSAttendance = {
      id: id,
      attendId: attendId
    }

    this.apiService.registerAssistanceParticipant(attendance).then(
      assist => {
        if(assist["attendId"] == "A"){
          this.messageService.add({severity:'success', summary: 'Registro de Asistencia', detail: "Se registro Asistencia Correctamente", life: 3000});
        }else if(assist["attendId"] == "N"){
          this.messageService.add({severity:'warn', summary: 'Registro de Asistencia', detail: "Se registro Inasistencia Correctamente", life: 3000});
        }
        this.countAssist();

    }).catch(error => {
      console.error(error);
      this.messageService.add({severity:'error', summary: 'Registro de Asistencia', detail: error, life: 3000});
    });


  }

  countAssist(){
    this.totalAssist = 0;
    this.listParticipantAssist.forEach( (participant) =>  {
      if(participant.isAssist)
        this.totalAssist++;
    });
  }
  getSecurity(){
    this.apiService.findSecurityById(
      {  
        "id":this.token
       }
      ).then(
      data => {
        this.security = data;           
        this.getTranslatedLabels();
    });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];
  
    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_church,this.lbl_name,this.lbl_Service,this.lbl_schedule,this.lbl_date,this.lbl_participants,this.lbl_id,this.lbl_last_name,this.lbl_search,
        this.lbl_back,this.lbl_total,this.lbl_there_are,this.lbl_number,this.lbl_attendance,this.lbl_place_where_provide,this.lbl_session]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
       
        this.lbl_church=map.get(this.lbl_church);
        this.lbl_name=map.get(this.lbl_name);
        this.lbl_Service=map.get(this.lbl_Service);
        this.lbl_schedule=map.get(this.lbl_schedule);
        this.lbl_date=map.get(this.lbl_date);
        this.lbl_participants=map.get(this.lbl_participants);
        this.lbl_last_name=map.get(this.lbl_last_name);
        this.lbl_search=map.get(this.lbl_search);
        this.lbl_back=map.get(this.lbl_back);
        this.lbl_total=map.get(this.lbl_total);
        this.lbl_there_are=map.get(this.lbl_there_are);
        this.lbl_number=map.get(this.lbl_number);
        this.lbl_attendance=map.get(this.lbl_attendance);
        this.lbl_id=map.get(this.lbl_id);
        this.lbl_session=map.get(this.lbl_session);
        this.lbl_place_where_provide=map.get(this.lbl_place_where_provide);
           });
    }
}
